export const isMobile = matchMedia("(max-width:1024px)").matches;
